import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Settings, Shield, Database, Globe } from "lucide-react";
import RoleDiagnostics from "./RoleDiagnostics";

export default function AdminSettings() {
  return (
    <div className="space-y-6">
      <RoleDiagnostics />
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Settings className="h-5 w-5" />
            Platform Settings
          </CardTitle>
          <CardDescription>General platform configuration</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex items-center justify-between p-3 rounded-lg border">
            <div className="flex items-center gap-3">
              <Shield className="h-5 w-5 text-primary" />
              <div>
                <p className="font-medium text-sm">Authentication</p>
                <p className="text-xs text-muted-foreground">Email + password authentication enabled</p>
              </div>
            </div>
            <Badge variant="secondary">Active</Badge>
          </div>
          <div className="flex items-center justify-between p-3 rounded-lg border">
            <div className="flex items-center gap-3">
              <Database className="h-5 w-5 text-primary" />
              <div>
                <p className="font-medium text-sm">Database</p>
                <p className="text-xs text-muted-foreground">Lovable Cloud backend connected</p>
              </div>
            </div>
            <Badge variant="secondary">Connected</Badge>
          </div>
          <div className="flex items-center justify-between p-3 rounded-lg border">
            <div className="flex items-center gap-3">
              <Globe className="h-5 w-5 text-primary" />
              <div>
                <p className="font-medium text-sm">Stripe Payments</p>
                <p className="text-xs text-muted-foreground">Live mode payments enabled</p>
              </div>
            </div>
            <Badge variant="secondary">Live</Badge>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
